import { fetchInternalApiJson } from '../../session-history/cloud/internal-api.js';
import type { CloudFetchParams } from '../../session-history/cloud/types.js';
import type { IntegrationContentResult } from './types.js';

export async function fetchCloudIntegrationContent(
  params: CloudFetchParams & {
    sessionId: string;
    url: string;
    associateAsSessionTicket?: boolean;
  },
): Promise<{ ok: true; data: IntegrationContentFetchResult } | { ok: false; error: string }> {
  return fetchInternalApiJson<IntegrationContentFetchResult>({
    ...params,
    path: `/internal/sessions/${encodeURIComponent(params.sessionId)}/integrations/content`,
    errorLabel: 'Integration content fetch failed',
    method: 'POST',
    body: {
      url: params.url,
      associateAsSessionTicket: params.associateAsSessionTicket !== false,
    },
  });
}
